(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name MenuloginController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('MenuloginController', MenuloginController);

    MenuloginController.$inject = ['UserService','$scope','$timeout'];

    function MenuloginController(UserService,$scope,$timeout)
    {
        var vm = this;
        vm.limit = 100;
        vm.offset = 0;
        vm.search = "";
        vm.users = []; 


        vm.options = {
		  ajax: {
		    url: '/middleware/users',
		    dataType: 'json'
		    // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
		  }
		}


        UserService.getUsers().then(function(data)
        	{
        		console.log(data);
        		vm.users = data;
        		$timeout(function(){
        			$scope.$broadcast("recreate_select2");	
        		});

        	});

              
    }


})();